import BonificationScreen from './BonificationScreen';
export default BonificationScreen;
